import React, { useEffect } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import Drawer from './../shared/components/Drawer'
import Menu from './../shared/components/Menu'

export default function Layout(props) {
  const isMobile = useMediaQuery('(max-width:767px)')

  useEffect(() => {
    document.title = props.title + ' | Integrity 1st Car Pros'
  }, [props.title])

  return (
    <>
      <div>
        {!isMobile ? <Menu /> : null}
        <Drawer {...props} />
      </div>
    </>
  )
}
